var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 52.5H7V70.5H27V52.5Z",
    fill: "#93B5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34.5H30V70.5H50V34.5Z",
    fill: "#5B8BF4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10.5H53V70.5H73V10.5Z",
    fill: "#2F68E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBar);
export default __webpack_public_path__ + "static/media/bar.bdd6012bad83f968112bd2777f2092eb.svg";
export { ForwardRef as ReactComponent };